enum BienAVendreFilters {
  Tous = 'ALL',
  DejaVus = 'ALREADY-SEEN',
  Favoris = 'FAVORITES',
}

export default BienAVendreFilters
